/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    MANAGE_LECTURE: {
        name: 'write:MANAGE_LECTURE',
        bitPermissions: 1,
    },
    SEND_MESSAGE_TO_LECTURE_ATTENDEES: {
        name: 'write:SEND_MESSAGE_TO_LECTURE_ATTENDEES',
        bitPermissions: 2,
    },
    MANAGE_CLIENT_ORDER: {
        name: 'write:MANAGE_CLIENT_ORDER',
        bitPermissions: 4,
    },
    READ_OFFICE_CLIENTS: {
        name: 'read:READ_OFFICE_CLIENTS',
        bitPermissions: 8,
    },
    WRITE_OFFICE_CLIENTS: {
        name: 'write:WRITE_OFFICE_CLIENTS',
        bitPermissions: 16,
    },
    READ_OFFICE_CLIENT_ORDERS: {
        name: 'read:READ_OFFICE_CLIENT_ORDERS',
        bitPermissions: 32,
    },
    WRITE_SUPERADMIN_OFFICE_SETTINGS: {
        name: 'write:WRITE_SUPERADMIN_OFFICE_SETTINGS',
        bitPermissions: 64,
    },
    WRITE_EXTENDED_OFFICE_SETTINGS: {
        name: 'write:WRITE_EXTENDED_OFFICE_SETTINGS',
        bitPermissions: 128,
    },
    WRITE_ORGANISATION_TARIFF_INFO: {
        name: 'write:WRITE_ORGANISATION_TARIFF_INFO',
        bitPermissions: 256,
    },
    READ_TARIFF_INFO: {
        name: 'read:tariff_info',
        bitPermissions: 512,
    },
    READ_OFFICE_SETTINGS: {
        name: 'read:office_settings',
        bitPermissions: 1024,
    },
    // for superadmin only
    READ_OFFICE_MONEY: {
        name: 'read:READ_OFFICE_MONEY',
        bitPermissions: 2048,
    },
};
